import React from "react";
import { makeStyles, Typography, CircularProgress } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import FileIcon from "@material-ui/icons/AttachFile";

const useStyles = makeStyles({
  previewCard: {
    backgroundColor: "#ddd",
    borderRadius: 5,
    display: "flex",
    boxSizing: "border-box",
    padding: "8px",
    cursor: "pointer",
  },
});

const FilePreviewCard = (props) => {
  const classes = useStyles();

  const {
    fileName,
    removeFileHandler,
    fileLink,
    isDeletingFile,
    fileId,
  } = props;

  return (
    <div
      style={{
        position: "relative",
        width: "auto",
        marginRight: "16px",
        marginBlock: 10,
      }}
    >
      {isDeletingFile ? (
        <CircularProgress
          size={15}
          style={{ position: "absolute", top: -8, right: -8 }}
        />
      ) : (
        <CancelIcon
          style={{
            marginRight: 10,
            position: "absolute",
            top: -9,
            right: -18,
            fontSize: 16,
            cursor: "pointer",
          }}
          onClick={removeFileHandler}
        />
      )}
      <a
        href={fileLink}
        // key={file.id}
        target="_blank"
        style={{ color: "inherit", textDecoration: "none" }}
      >
        <div className={classes.previewCard}>
          <FileIcon />
          <Typography variant="body1">
            {fileName}
          </Typography>
        </div>
      </a>
    </div>
  );
};

export default FilePreviewCard;
